// extracted by mini-css-extract-plugin
export var bounce = "Audit-module--bounce--3a006";
export var dotMoveLeft = "Audit-module--dot-move-left--61c38";
export var dotMoveRight = "Audit-module--dot-move-right--80181";
export var gradient = "Audit-module--gradient--f38da";
export var icon = "Audit-module--icon--7823d";
export var intro = "Audit-module--intro--b39f6";
export var separatorWidth = "Audit-module--separator-width--387df";
export var title = "Audit-module--title--2b62f";
export var wrapper = "Audit-module--wrapper--c8fae";